export default __webpack_public_path__ + "static/media/icon_disadvantage_13operater.dd6ee9ee.png";